import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { Post } from '../post/post';
import { Comment } from '../comment/comment';
import { CommonProvider } from '../common';

/*
  Generated class for the LikeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LikeProvider {

  constructor(public http: HttpClient, private commonProvider: CommonProvider) {}

  private _url: string = 'api/v1/like';
  private _postUrl: string = 'api/v1/post';
  private _commentUrl: string = 'api/v1/comment';

  getAllForPost(post: Post | string): Observable<Response<Like>> {
    const id = typeof post == 'string' ? post : post.id;
    return this.http.get<Response<Like>>(this.commonProvider.apiUrl + this._postUrl + `/${id}/like/list`);
  }

  getAllForComment(comment: Comment | string): Observable<Response<Like>> {
    const id = typeof comment == 'string' ? comment : comment.id;
    return this.http.get<Response<Like>>(this.commonProvider.apiUrl + this._commentUrl + `/${id}/like/list`);
  }

  get(id: string): Observable<Response<Like>> {
    return this.http.get<Response<Like>>(this.commonProvider.apiUrl + this._url + `/${id}/show`);
  }

  delete(like: Like | string): Observable<Response<any>> {
    const id = typeof like == 'string' ? like : like.id;
    return this.http.post<Response<any>>(this.commonProvider.apiUrl + this._url + `/${id}/delete`, null);
  }

}

export interface Like {
  id: string;
  user_id: string;
  post_id?: string;
  company_id?: string;
  comment_id?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}



// WEBPACK FOOTER //
// ./src/providers/like/like.ts